import { Component, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MembershipService } from '../memberships/Services/Membership.service';

@Component({
  selector: 'app-apply-coupon',
  imports: [TranslateModule, CommonModule, ReactiveFormsModule, ToasterComponent],
  templateUrl: './apply-coupon.component.html',
  styleUrl: './apply-coupon.component.css'
})
export class ApplyCouponComponent {

  CouponForm!: FormGroup;
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  id: number | null = null;
  finalPrice: number = 0;
  logs: any[] = [];
  price: number = 0;
  previewUrls: (string | ArrayBuffer)[] = [];
  showMembershipModal: boolean = false;
  @Input() membershipData: any;
  @Input() membershipId!: number;
  @Output() membershipDataUpdated = new EventEmitter<void>();
  @Output() getMembershipByUserId = new EventEmitter<void>();



  private fb = inject(FormBuilder);

  private MembershipService = inject(MembershipService)
    private translate = inject(TranslateService)

  ngOnInit() {
    this.CouponForm = this.fb.group({
      coupon: ['']
    });

    this.id = +localStorage.getItem('userId')!;
    // this.MembershipService.getMembershipByUserId(this.id).subscribe({
    //   next: (res: any) => {
    //     // console.log(" this.isUserCreatedBefore ", this.isUserCreatedBefore)
    //     // console.log("countries", this.countries)
    //     // console.log("this.selectedCountry", this.selectedCountry)
    //     this.membershipId = res.value.items[0].id;
    //     localStorage.setItem("membershipId", this.membershipId.toString());
    //   }
    // })
  }

  // ngAfterViewInit() {

  //   const modalEl = document.getElementById('applyCoupon');

  //   modalEl?.addEventListener('shown.bs.modal', () => {
  //     this.CouponForm.patchValue({ coupon: '' });
  //     // this.getMembershipById();  // 👈 هيتنفذ كل ما المودال يتفتح
  //   });

  // }

  ApplyCoupon() {
    const coupon = this.CouponForm.get('coupon')?.value || '';

    const params = {
      membershipId: this.membershipId,
      coupon: coupon
    };

    this.MembershipService.ApplyCoupon(params).subscribe({
      next: (response: any) => {
        if (response.succeeded) {
          // this.closeMembershipModal()
          // console.log("succeeded");
          this.toastType = 'success';
          this.toastMessage = this.translate.instant('MEMBERSHIP.SUCESSFULLY_ADDED_COUPON');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
          this.membershipDataUpdated.emit(); 
          this.getMembershipByUserId.emit();

          // this.getMembershipById()
        }
        else {
          // this.closeMembershipModal()
          this.toastType = 'error';
          this.toastMessage = response.errors[0];
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      }
    })
  }


  RemoveCoupon() {
    const coupon = this.CouponForm.get('coupon')?.value || '';

    const params = {
      membershipId: this.membershipId,
    };

    this.MembershipService.removeCoupon(params).subscribe({
      next: (response: any) => {
        if (response.succeeded) {
          this.toastType = 'success';
          this.toastMessage = this.translate.instant('MEMBERSHIP.SUCESSFULLY_REMOVED_COUPON');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
          this.membershipDataUpdated.emit(); 
          this.getMembershipByUserId.emit();
        }
        else {
          // this.closeMembershipModal()
          this.toastType = 'error';
          this.toastMessage = response.errors[0];
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['membershipData'] && this.membershipData) {
      // تحديث القيم كل مرة يوصل فيها Input جديد
      this.finalPrice = this.membershipData.finalPrice;
      this.price = this.membershipData.price;
      // إعادة تهيئة الحقل لتفريغه عند فتح المودال
      if (this.CouponForm) {
        this.CouponForm.patchValue({ coupon: '' });
      }
    }
  }

  // getMembershipById(){
  //   this.finalPrice = this.membershipData.finalPrice;
  //   this.price = this.membershipData.price;
  //   this.logs = this.membershipData.logs;
  // }


  // getMembershipById() {
  //   this.MembershipService.getMemberShipById(this.membershipId).subscribe({
  //     next: (res: any) => {
  //       this.finalPrice = res.value.finalPrice;
  //       this.price = res.value.price;
  //       this.logs = res.value.logs;
  //       this.previewUrls = [...this.previewUrls, ...res.value.attachments.map((att: any) => att.path)];
  //       // console.log("this.previewUrls", this.previewUrls)
  //     }
  //   })
  // }

  closeMembershipModal() {
    this.showMembershipModal = false;

    // خزّن إنه قفل المودال
    localStorage.setItem('membershipModalClosed', 'true');

    // إزالة الباك دروب لو لسه موجود
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();
  }


}
